Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.logInTitleText = "Log In";
exports.logInBodyText = "The reason why we require login.";
exports.loginFacebookButtonText = "Log in With Facebook";
exports.loginGoogleButtonText = "Log in With Google";
exports.loginButtonText = "Log in with email and password";
exports.orText = "or";
// Customizable Area End